const drawerDim={
    width:272,
    collapsedWidth: 70,
    height:64,
    bottom:40
}

export default drawerDim;